import { getUnassignedTaskCount } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useGetUnassignedTaskCount = () => {
  return useQuery(['unassigned-task-count'], () => getUnassignedTaskCount());
};
